import { useSWR } from '@tiger/swr';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';
import { parseAccountInfo } from './helper';
import { BankSecuritiesGuideBankInfo } from './type';

export const useChoiceList = () => {
    return useSWR(
        {
            url: API.DEPOSIT.getChoiceList(),
            params: {
                account_type: 'bs',
                license: 'MARSCO',
                customer_id: security.currentCustomerId
            }
        },
        {
            dataChain: res => res.data,
            immutable: true,
            shouldRetryOnError: false
        }
    );
};

// 获取收款账户信息与银行列表
const bankInfo: Record<string, BankSecuritiesGuideBankInfo> = {};

export async function getAccountAndBankInfo(bankId: string) {
    if (bankInfo[bankId] && !bankInfo[bankId].need_van_account) {
        return Promise.resolve(bankInfo[bankId]);
    }

    const params = {
        account_type: 'bs',
        license: 'MARSCO',
        customer_id: security.currentCustomerId
    };

    const otherData: Record<string, any> = {};

    return http.get<BankSecuritiesGuideBankInfo>(API.DEPOSIT.getAccountAndBankInfo(bankId), { params }).then(resp => {
        return (bankInfo[bankId] = parseAccountInfo(resp.data, resp.need_van_account, otherData));
    });
}
